import React from 'react';
import '../style/css/sidenavbar.css'
import NavBar from '../pages/NavBar'

const SideNavbar = () => {
    return (
        <div className={'sidenavbar-container'}>
            <div className={'navbar-btn-continer'}>
                <button>תפריט</button>
                <button>הזמנות אינטרנט</button>
            </div>
            <NavBar/>
        </div>
    );
};

export default SideNavbar;